module.exports = __webpack_public_path__ + "img/forgot-password.88b0d5d2.jpg";